export default {
  availability: jest.fn(),
  availabilityAlert: jest.fn(),
  checkProfile: jest.fn(),
  prescoringProfile: jest.fn(),
  postPrescoringProfile: jest.fn(),
  rentalsConditions: jest.fn(),
  createAppointment: jest.fn(),
  cancelAppointment: jest.fn(),
};
